
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.735 2C16.456 2 17.992 3.543 18 6.264v7.472C18 16.456 16.456 18 13.735 18H6.264C3.544 18 2 16.456 2 13.736V6.264C2 3.544 3.543 2 6.264 2h7.471zM10.4 5.304a.672.672 0 00-1.025.632v8.152c.041.344.328.6.664.6a.661.661 0 00.664-.6V5.936a.652.652 0 00-.303-.632zM6.664 7.928a.658.658 0 00-.704 0 .673.673 0 00-.312.632v5.528c.031.344.32.6.663.6a.661.661 0 00.664-.6V8.56a.674.674 0 00-.311-.632zm7.407 2.904a.67.67 0 00-.711 0 .645.645 0 00-.304.632v2.624c.032.344.32.6.664.6a.674.674 0 00.664-.6v-2.624a.667.667 0 00-.313-.632z","fill":"#94A3B8"}})])
          )
        }
      }
    